import { useEffect } from 'react'
import { Cta } from '../components/Cta'
import { Customers } from '../components/Customers'
import { DemoVideo } from '../components/DemoVideo'
import { Footer } from '../components/Footer'
import { GetInTouch } from '../components/GetInTouch'
import { Header } from '../components/Header'
import { Hero } from '../components/Hero'
import { HowItWorks } from '../components/HowItWorks'
import { Testimonials } from '../components/Testimonials'

import { homePageView } from 'tag-manager/page_view'
import { Seo } from 'ui-components/components/atoms/Seo'

const seo = {
  title: 'Mapstack | Magically Create Stunning Maps with AI',
  description:
    'Mapstack is the easiest way to turn places, addresses, regions, customers, sales, resources, and assets into interactive maps. No experience needed — just upload, map, and share.',
  keywords:
    'interactive maps, AI mapping tool, map generator, no-code mapping, business mapping, map from spreadsheet, location data visualisation, customer mapping, create map online, Mapstack'
}

export default function Home() {
  useEffect(() => {
    homePageView()
  }, [])

  return (
    <>
      <Seo
        title={seo.title}
        description={seo.description}
        openGraph={{
          title: seo.title,
          description: seo.description,
          images: [
            {
              url: 'https://mapstack.io/images/og_image.webp',
              secureUrl: 'https://mapstack.io/images/og_image.webp',
              alt: 'Mapstack - Visualize and Map Location Data Instantly',
              type: 'image/webp',
              width: 1200,
              height: 630
            }
          ],
          url: 'https://mapstack.io/',
          siteName: 'Mapstack'
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: seo.keywords
          }
        ]}
      />

      <Header />
      <div className='bg-gray-50'>
        <Hero />
        <Customers />
        <HowItWorks />
        <DemoVideo />
        <Testimonials />
        <Cta />
        <GetInTouch />
        <Footer />
      </div>
    </>
  )
}

export const getServerSideProps = () => {
  return {
    props: {}
  }
}
